import { KeyedMutator } from 'swr';

import { Trans } from '@/components/tools/translation';

export type ReportFormErrorFallbackProps = {
    relaunchRequest: KeyedMutator<unknown>;
};

const ReportFormErrorFallback = ({ relaunchRequest }: ReportFormErrorFallbackProps) => (
    <div className="w-fill flex min-h-[500px] items-center justify-center rounded-md bg-white dark:bg-icoDarkMode-deepBlack">
        <p>
            <Trans
                i18nKey="errors:error_server_occurred"
                components={{
                    tag0: (
                        <button
                            className="text-icoBlue underline"
                            data-testid="report-form-error-fallback-button"
                            onClick={() => relaunchRequest(undefined)}
                        />
                    )
                }}
            />
        </p>
    </div>
);

export default ReportFormErrorFallback;
